export default __webpack_public_path__ + "static/media/logo-square.210ae394.png";